import { actions } from '../../utils/constants';

const DEFAULT_STATE = {
    data: [],
    loading: false,
    class_template_tests: {},
};

export default (state = DEFAULT_STATE, { type, payload }) => {
    const newData = [...state.data];

    switch (type) {
        case actions.CLASSES_FETCHED:
            return { ...state, data: payload };

        // eslint-disable-next-line no-case-declarations
        case actions.CLASS_FETCHED:
            const theClass = newData.find(c => c.classId === payload.classId);
            if (theClass) {
                Object.assign(theClass, payload);
            } else {
                newData.push(payload);
            }
            return { ...state, data: newData };

        case actions.UPDATE_CLASS:
            if (newData.findIndex(c => c.classId === payload.classId) !== -1) {
                newData[newData.findIndex(c => c.classId === payload.classId)] =
                    payload.value;
            }
            return { ...state, data: newData };

        case actions.CLASS_CREATED:
            newData.push(payload);
            return { ...state, data: newData };

        case actions.CLASS_DELETED:
            return {
                ...state,
                data: newData.filter(c => c.classId !== payload),
            };

        case actions.CLASSES_FETCH_LOADING:
            return { ...state, ...payload };

        case actions.CHANGE_CLASS_TEMPLATE_TESTS:
            return { ...state, class_template_tests: payload };

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/components/classes/classes.reducer.js